import React from 'react';
import ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import posthog from 'posthog-js';
import './index.css';
import { routeConfig } from './App';
import reportWebVitals from './reportWebVitals';

// Initialize PostHog
if (process.env.NODE_ENV === 'production' && process.env.REACT_APP_POSTHOG_KEY) {
  posthog.init(process.env.REACT_APP_POSTHOG_KEY, {
    api_host: '/ingest',
    ui_host: 'https://us.i.posthog.com',
    person_profiles: 'always',
    capture_pageview: false, // Manual capture in App.js to avoid double counting
    capture_pageleave: true
  });
}

const router = createBrowserRouter(routeConfig);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
